import { useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { UsersRepositoryToken } from '../../di/tokens';

export function useUser(userId: string) {
  const repository = container.resolve(UsersRepositoryToken);
  return useQuery({
    queryKey: ['users', userId],
    queryFn: () => repository.getById(userId),
    staleTime: 1000 * 60 * 5,
    enabled: !!userId,
  });
}
